type GTMConsent = "denied" | "granted";
export type GTMConsentTagName = "ad_storage" | "analytics_storage" | "ad_user_data" | "ad_personalization";

export type GTMConsentData = {
    [tagName in GTMConsentTagName]?: GTMConsent;
};

class GoogleTagManager {
    private idleTime = 5000;
    private initialised = false;
    private idleTimeout: NodeJS.Timeout;
    private eventListener: (e: Event) => void;
    constructor() {
        this.eventListener = this.eventHandler.bind(this);

        window.addEventListener("scroll", this.eventListener);
        window.addEventListener("mousemove", this.eventListener);
        window.addEventListener("touchstart", this.eventListener);

        this.idleTimeout = setTimeout(() => {
            this.init();
        }, this.idleTime);
    }

    eventHandler(e: Event) {
        clearTimeout(this.idleTimeout);
        if (!this.initialised) this.init();
        e.currentTarget.removeEventListener(e.type, this.eventListener);
    }

    private init() {
        if (this.initialised) return;

        const scriptTag = document.createElement('script');
        scriptTag.type = "text/javascript";
        scriptTag.async = true;
        scriptTag.addEventListener("load", this.sendPageView.bind(this));
        scriptTag.src = `https://www.googletagmanager.com/gtm.js?id=${"GTM-MM2VCSGB"}`;


        document.head.appendChild(scriptTag);
    }

    getLocalData() : GTMConsentData {
        const storage = localStorage.getItem("MORLINY_FOODS_COM_GOOGLE_TAGS");
        return storage ? JSON.parse(storage) : null;
    }

    gtag(..._args: any[]) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(arguments);
    }

    pushToDataLayer(data : { [eventName: string]: any }) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    }

    sendPageView() {
        const defaultConsent : GTMConsentData = this.getLocalData() ?? {
            "analytics_storage": "denied",
            "ad_storage": "denied",
            "ad_user_data": "denied",
            "ad_personalization": "denied"
        };

        this.gtag("consent", "default", defaultConsent);
        localStorage.setItem("MORLINY_FOODS_COM_GOOGLE_TAGS", JSON.stringify(defaultConsent));

        this.pushToDataLayer({
            "event": "default_consent"
        });

        this.pushToDataLayer({
            "gtm.start": (new Date()).getTime(),
            "event": "gtm.js"
        })
    }

    denyConsent(tagName : GTMConsentTagName) {
        this.gtag("consent", "update", {
            [tagName] : "denied"
        });

        const data : GTMConsentData = this.getLocalData() ?? {};
        data[tagName] = "denied";

        localStorage.setItem(
            "MORLINY_FOODS_COM_GOOGLE_TAGS",
            JSON.stringify(data)
        )
    }

    grantConsent(tagName: GTMConsentTagName) {
        this.gtag("consent", "update", {
            [tagName]: "granted"
        });

        const data : GTMConsentData = this.getLocalData() ?? {};
        data[tagName] = "granted";

        localStorage.setItem(
            "MORLINY_FOODS_COM_GOOGLE_TAGS",
            JSON.stringify(data)
        )
    }

    consentAll() {
        this.grantConsent("ad_storage");
        this.grantConsent("analytics_storage");
        this.grantConsent("ad_user_data");
        this.grantConsent("ad_personalization");
        this.setPromptSeen();
    }

    setPromptSeen() {
        localStorage.setItem(
            "MORLINY_FOODS_COM_COOKIES_PROMPT",
            "seen"
        )

        localStorage.setItem(
            "MORLINY_FOODS_COM_COOKIES_TIMEOUT",
            (new Date()).getTime().toString()
        );
    }
}

const googleTagManager = new GoogleTagManager();
export default googleTagManager;